import { v4 } from 'uuid';
import { getUTCTimestamp } from 'utils/helpers/time';

const TRACKING_SESSION_KEY = 'anetaed-tracking-session';

type TrackingSessionData = {
  uuid: string;
  startTimestamp: number;
  userId?: string;
};

export const startTrackingSession = (): TrackingSessionData => {
  const data: TrackingSessionData = {
    uuid: v4(),
    startTimestamp: getUTCTimestamp(),
  };

  sessionStorage.setItem(TRACKING_SESSION_KEY, JSON.stringify(data));

  return data;
};

export const getTrackingSessionData = (): TrackingSessionData | null => {
  const data = sessionStorage.getItem(TRACKING_SESSION_KEY);

  try {
    return JSON.parse(data as string) as TrackingSessionData;
  } catch (e) {
    return null;
  }
};

export const addUserDataToTrackingSession = (
  params: Pick<TrackingSessionData, 'userId'>
): void => {
  const sessionData = getTrackingSessionData() || {};

  sessionStorage.setItem(
    TRACKING_SESSION_KEY,
    JSON.stringify({ ...sessionData, ...params })
  );
};
